module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/1@2x_b3c32184ca9eb935073b8de2ee5c81a1.png";